import { AdapterApi } from '@voladeum/client';
import { VoladeumResponse } from 'client/types';

import { Axios } from '../../axios';

import { normalizeAdapters } from './normalizers';
import { Adapter } from './types';

export class VoladeumAdapters extends Axios {
  async list(): Promise<VoladeumResponse<Adapter[]>> {
    const res = await this.get<VoladeumResponse<AdapterApi[]>>('/v1/adapters');
    return {
      success: res.success,
      error: res.error,
      data: normalizeAdapters(res.data),
    };
  }
}
